import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TranslateLoader, TranslateModule, TranslateModuleConfig, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { PreferenciasSuscripcionComponent } from './preferencias-suscripcion/preferencias-suscripcion.component';
import { ErrorsModule } from 'src/app/errors/errors.module';
import { Error404Component } from 'src/app/errors/components/error404/error404.component';

function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/suscripcion/', '.json');
}
const translateConfig: TranslateModuleConfig = {
    defaultLanguage: 'es',
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    },
    isolate: true
}

const routes: Routes = [
    {
        path: PreferenciasSuscripcionComponent.nombreRuta,
        component: PreferenciasSuscripcionComponent
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: PreferenciasSuscripcionComponent.nombreRuta
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: `${ErrorsModule.nombreRuta}/${Error404Component.nombreRuta}`
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        TranslateModule.forChild(translateConfig)
    ],
    exports: [RouterModule, TranslatePipe],
    providers: [TranslateModule]
})
export class SuscripcionRoutingModule { }
